import { mapDTO } from '@twistezo/ts-dto-mapper'
import { UpdateDomainsMutationVariables } from 'gql/graphql'

import { DomainTableSchema } from 'features/inventory/domain/forms/DomainTableForm/schema'

type From = DomainTableSchema
type To = UpdateDomainsMutationVariables['input']

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({ domainsAttributes }: From): To => ({
      domainsAttributes: Object.entries(domainsAttributes).map(([id, attributes]) => ({
        id,
        ...attributes,
      })),
    }),
  )
